/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-03-02 16:45:19
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-20 18:00:45
 */
// import { Mesh } from "@babylonjs/core";
import { Vector3, } from '@babylonjs/core';
import MeshManage from '../meshManage';
import { CORNERDISTANCE, CORNEROUTDISTANCE, DISTANCE_FAUCET_MOVE, DISTANCE_FROM_FAUCET_TO_WALL, DISTANCE_FROM_HOLESINK_TO_WALL, DISTANCE_FROM_SINKEDGE_TO_SINKHOLE, DISTANCE_FROM_SINK_TO_EDGE, HALFCORNEROUTDISTANCE, TOPPANELCONFIG, } from './kitchenConfig';
import { getCornerCabinetFrameXZ } from './renderUtils';
import { CornerCabinetDirection } from './enum';
/**
 * 水槽位置的逻辑为 如果是无孔水槽 那么水槽距离台面边缘10cm  水龙头距离水槽柜背部6.5cm
 * 无孔水槽定位： carbinet.z/2(水槽柜最前方) + 台面多出的3.5cm - 10cm  - 水槽.z/2
 * 水龙头：-carbinet/2（水槽柜最后方） + 6.5cm
 * 右开关的水龙头向右平移3cm 尽量在中心位置
 * 如果是有孔水槽 那么水槽距离水槽柜背部2cm 水龙头在孔上面 初步估测为水龙头距离水槽带孔边的边缘3.5cm
 * 有孔水槽定位:  -carbinet/2（水槽柜最后面） + 2cm + 水槽.z/2
 * 水龙头：  -carbinet/2（水槽柜最后面） + 2cm + 3.5cm
 * 规则地址：https://confluence.build.ingka.ikea.com/pages/viewpage.action?pageId=417956430
 */
/**
 * 判断什么方向的转角柜  right or left
 * @param frame 柜体信息
 * @returns 转角柜柜门所在方向
 */
function cornerDirection(frame) {
    if (frame.longEdge === 1 || (frame.longEdge === 2 && frame.edge === 'length2')) {
        return 'right';
    }
    return 'left';
}
// 水龙头水槽相关位置调整
/**
 * 正常水槽柜水槽的位置 v2.2
 * @param {} frame 水槽柜信息
 * @param {*} Sink 水槽信息
 * @param {*} hasHole 是否为带孔水槽
 */
export function getCommonSinkPosition(frameMeshManage, sinkMeshManage, hasHole) {
    const position = {
        x: sinkMeshManage.mesh.position.x,
        y: frameMeshManage.getModelSize().y - sinkMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT,
        z: 0,
    };
    if (hasHole) {
        position.z = -frameMeshManage.getModelSize().z / 2 + sinkMeshManage.getModelSize().z / 2
            + DISTANCE_FROM_HOLESINK_TO_WALL;
    }
    else {
        position.z = frameMeshManage.getModelSize().z / 2 + TOPPANELCONFIG.DEPTH
            - sinkMeshManage.getModelSize().z / 2 - DISTANCE_FROM_SINK_TO_EDGE;
    }
    return position;
}
/**
 * 转角柜上面水槽的位置信息
 * @param frame 水槽柜信息
 * @param frameMeshManage 水槽柜mesh
 * @param sinkMeshManage 水槽mesh
 * @param hasHole 是否有洞
 * @returns 水槽position
 */
export function getCornerSinkPosition(frame, frameMeshManage, sinkMeshManage, hasHole) {
    const parentPosition = frameMeshManage.mesh.position;
    const parentSize = frameMeshManage.getModelSize();
    const childSize = sinkMeshManage.getModelSize();
    const y = frameMeshManage.getModelSize().y - sinkMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT;
    let x;
    let z;
    if (hasHole) {
        z = -parentSize.z / 2 + DISTANCE_FROM_HOLESINK_TO_WALL + childSize.z / 2;
    }
    else {
        z = parentSize.z / 2 - 2 * HALFCORNEROUTDISTANCE
            + TOPPANELCONFIG.DEPTH - DISTANCE_FROM_SINK_TO_EDGE - childSize.z / 2;
    }
    // 右转角柜
    if (cornerDirection(frame) === 'right') {
        x = parentPosition.x + parentSize.x / 2 - childSize.x / 2 - CORNERDISTANCE;
    }
    else {
        x = parentPosition.x - parentSize.x / 2 + childSize.x / 2 + CORNERDISTANCE;
    }
    return { x, y, z };
}
export function getNewSinkPosition(frame, frameMeshManage, sinkMeshManage, hasHole, isCorner) {
    if (isCorner) {
        return getCornerSinkPosition(frame, frameMeshManage, sinkMeshManage, hasHole);
    }
    return getCommonSinkPosition(frameMeshManage, sinkMeshManage, hasHole);
}
/**
 * 正常水槽柜的水龙头信息 v2.2
 * @param {*} frameMeshManage 水槽柜信息
 * @param {*} sinkMeshManage 水槽信息
 * @param {*} faucetMesh 水龙头信息
 * @param {*} hasHole 是否为带孔水槽
 */
export function getCommonFaucetPosition(frameMeshManage, sinkMeshManage, faucetMesh, hasHole, faucetInfo) {
    let x;
    const y = frameMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT;
    let z;
    if (faucetInfo.specialFlg) {
        x = faucetMesh.mesh.position.x + DISTANCE_FAUCET_MOVE;
    }
    else {
        x = faucetMesh.mesh.position.x;
    }
    if (hasHole) {
        z = -frameMeshManage.getModelSize().z / 2
            + faucetMesh.getModelSize().z / 2
            + DISTANCE_FROM_HOLESINK_TO_WALL
            + DISTANCE_FROM_SINKEDGE_TO_SINKHOLE;
    }
    else {
        z = -frameMeshManage.getModelSize().z / 2 + faucetMesh.getModelSize().z / 2 + DISTANCE_FROM_FAUCET_TO_WALL;
    }
    return { x, y, z };
}
export function getCornerFaucetPosition(frame, frameMeshManage, sinkMeshManage, faucetMesh, hasHole, faucetInfo) {
    const parentSize = frameMeshManage.getModelSize();
    const childSize = faucetMesh.getModelSize();
    const y = frameMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT;
    let { x } = sinkMeshManage.mesh.position;
    if (faucetInfo.specialFlg) {
        x += DISTANCE_FAUCET_MOVE;
    }
    let z;
    if (hasHole) {
        z = -parentSize.z / 2 + DISTANCE_FROM_HOLESINK_TO_WALL + DISTANCE_FROM_SINKEDGE_TO_SINKHOLE + childSize.z / 2;
    }
    else {
        z = -parentSize.z / 2 + childSize.z / 2 + DISTANCE_FROM_FAUCET_TO_WALL;
    }
    return { x, y, z };
}
/**
 * 获取v2.2版本以上的水槽位置
 * @param frame 水槽柜信息
 * @param frameMeshManage 水槽柜mesh
 * @param sinkMeshManage 水槽mesh
 * @param hasHole 是否带孔水槽
 * @param isCorner 是否转角柜
 */
export function getNewFaucetPosition(frame, frameMeshManage, sinkMeshManage, faucetMesh, hasHole, isCorner, faucetInfo) {
    if (isCorner) {
        return getCornerFaucetPosition(frame, frameMeshManage, sinkMeshManage, faucetMesh, hasHole, faucetInfo);
    }
    return getCommonFaucetPosition(frameMeshManage, sinkMeshManage, faucetMesh, hasHole, faucetInfo);
}
/**
 * 获取水龙头的位置信息 v2.1（含）以下
 * @param {*} frameMeshManage 水槽柜信息
 * @param {*} sinkMeshManage 水槽信息
 * @param {*} faucetMesh 水龙头信息
 * @param {*} isCorner 是否为转角柜
 */
export function getOldFaucetPosition(frameMeshManage, sinkMeshManage, faucetMesh, isCorner) {
    let position = null;
    if (isCorner) {
        position = {
            x: sinkMeshManage.mesh.position.x,
            y: frameMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT,
            z: sinkMeshManage.mesh.position.z - sinkMeshManage.getModelSize().z / 2 + CORNEROUTDISTANCE,
        };
    }
    else {
        position = {
            x: faucetMesh.mesh.position.x,
            y: frameMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT,
            z: -faucetMesh.getModelSize().z / 2,
        };
    }
    return position;
}
/**
 * 获取v2.1（含）以下的水槽位置
 * @param {*} frame 水槽柜的整体信息
 * @param {*} frameMeshManage 水槽柜mesh
 * @param {*} sinkMeshManage 水槽mesh
 * @param {*} isCorner 是否为转角柜
 */
export function getOldSinkPosition(frame, frameMeshManage, sinkMeshManage, isCorner) {
    let position;
    if (isCorner) {
        const parentPosition = frameMeshManage.mesh.position;
        const parentSize = frameMeshManage.getModelSize();
        const childSize = sinkMeshManage.getModelSize();
        // 设置水槽在右转角柜的时候跟柜子的相对位置关系 柜子长度为cx,cy,cz  水槽为sx,sy,sz
        // x: cx/2-sx/2-边距
        // y: cy-sy+台面高度
        // z: 8公分/2
        // 左转角柜的位置信息主要修改X的位置  跟右转角柜刚好相反 -cx/2+sx/2+边距
        position = Object.assign({ y: frameMeshManage.getModelSize().y - sinkMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT }, getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, cornerDirection(frame), null, null));
    }
    else {
        position = {
            x: sinkMeshManage.mesh.position.x,
            y: frameMeshManage.getModelSize().y - sinkMeshManage.getModelSize().y + TOPPANELCONFIG.HEIGHT,
            z: sinkMeshManage.mesh.position.z,
        };
    }
    return position;
}
// 台面根据水槽不同位置挖洞
/**
 * 洞的位置跟水槽摆放的位置是相同的逻辑 但是水槽摆放的时候是在最开始加载的时候 所有模型都是原始定位点(0,0,0)
 * 挖洞的时候所有模型都已经摆放完毕，在计算位置的时候需要使用摆放之后的位置进行计算
 */
/**
 * 获取正常水槽柜的挖孔位置
 * @param frameMeshManage 水槽柜meshManage
 * @param SinkMeshManage 水槽meshmanage
 * @param hasHole 水槽是否有洞
 * @param topPanelPositionY 台面的厚度
 * @param lengthType 挖孔所在的边
 * @returns 挖孔的position
 */
export function getCommonSinkHolePosition(frameMeshManage, SinkMeshManage, hasHole, topPanelPositionY, lengthType) {
    const sinkCabinetSize = frameMeshManage.getModelSize();
    const sinkSize = SinkMeshManage.getModelSize();
    let x;
    let z;
    switch (lengthType) {
        case 'p2x':
            x = frameMeshManage.mesh.position.x;
            if (hasHole) {
                z = frameMeshManage.mesh.position.z
                    + sinkCabinetSize.z / 2 - DISTANCE_FROM_HOLESINK_TO_WALL - sinkSize.z / 2;
            }
            else {
                z = frameMeshManage.mesh.position.z
                    - sinkCabinetSize.z / 2 - TOPPANELCONFIG.DEPTH + DISTANCE_FROM_SINK_TO_EDGE + sinkSize.z / 2;
            }
            break;
        case 'x':
            x = frameMeshManage.mesh.position.x;
            if (hasHole) {
                z = frameMeshManage.mesh.position.z
                    - sinkCabinetSize.z / 2 + DISTANCE_FROM_HOLESINK_TO_WALL + sinkSize.z / 2;
            }
            else {
                z = frameMeshManage.mesh.position.z
                    + sinkCabinetSize.z / 2 - sinkSize.z / 2 - DISTANCE_FROM_SINK_TO_EDGE + TOPPANELCONFIG.DEPTH;
            }
            break;
        default:
            z = frameMeshManage.mesh.position.z;
            if (hasHole) {
                x = frameMeshManage.mesh.position.x
                    + sinkCabinetSize.x / 2 - DISTANCE_FROM_HOLESINK_TO_WALL - sinkSize.x / 2;
            }
            else {
                x = frameMeshManage.mesh.position.x
                    - sinkCabinetSize.x / 2 + sinkSize.x / 2 + DISTANCE_FROM_SINK_TO_EDGE - TOPPANELCONFIG.DEPTH;
            }
            break;
    }
    return {
        x, y: topPanelPositionY, z,
    };
}
/**
 * l3转角柜水槽挖洞位置 在l3上面且是转角柜的一定是左转角
 * @param frameMesh
 * @param sinkMesh
 * @param topPanelPositionY
 * @param hasHole
 */
export function getP2XCornerSinkHolePosition(frameMesh, sinkMesh, topPanelPositionY, hasHole) {
    const sinkSize = new MeshManage(sinkMesh).getModelSize();
    const sinkCabinetSize = new MeshManage(frameMesh).getModelSize();
    const sinkCabinetBounds = (frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.getHierarchyBoundingVectors()) || {
        min: new Vector3(0, 0, 0),
        max: new Vector3(0, 0, 0),
    };
    const y = topPanelPositionY;
    const x = ((frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.position.x) || 0) - sinkCabinetSize.x / 2 + CORNERDISTANCE + sinkSize.x / 2;
    let z = 0;
    if (hasHole) {
        z = sinkCabinetBounds.max.z - DISTANCE_FROM_HOLESINK_TO_WALL - sinkSize.z / 2;
    }
    else {
        z = sinkCabinetBounds.min.z - TOPPANELCONFIG.DEPTH + CORNEROUTDISTANCE
            + DISTANCE_FROM_SINK_TO_EDGE + sinkSize.z / 2;
    }
    return {
        x, y, z,
    };
}
/**
 * l1转角柜水槽挖洞位置  一定是右转角
 */
export function getXCornerSinkHolePosition(frameMesh, sinkMesh, topPanelPositionY, hasHole) {
    const sinkSize = new MeshManage(sinkMesh).getModelSize();
    const sinkCabinetSize = new MeshManage(frameMesh).getModelSize();
    const sinkCabinetBounds = (frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.getHierarchyBoundingVectors()) || {
        min: new Vector3(0, 0, 0),
        max: new Vector3(0, 0, 0),
    };
    const y = topPanelPositionY;
    const x = ((frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.position.x) || 0) - sinkCabinetSize.x / 2 + CORNERDISTANCE + sinkSize.x / 2;
    let z = 0;
    if (hasHole) {
        z = sinkCabinetBounds.min.z + DISTANCE_FROM_HOLESINK_TO_WALL + sinkSize.z / 2;
    }
    else {
        z = sinkCabinetBounds.max.z - CORNEROUTDISTANCE + TOPPANELCONFIG.DEPTH
            - DISTANCE_FROM_SINK_TO_EDGE - sinkSize.z / 2;
    }
    return { x, y, z };
}
/**
 * l2转角柜   可能是左转角也可能是右转角
 */
export function getZCornerSinkHolePosition(frameMesh, sinkMesh, topPanelPositionY, hasHole, cornerCabinetDirection) {
    const sinkSize = new MeshManage(sinkMesh).getModelSize();
    const sinkCabinetSize = new MeshManage(frameMesh).getModelSize();
    const sinkCabinetBounds = (frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.getHierarchyBoundingVectors()) || {
        min: new Vector3(0, 0, 0),
        max: new Vector3(0, 0, 0),
    };
    const y = topPanelPositionY;
    let x = 0;
    let z = 0;
    if (cornerCabinetDirection === CornerCabinetDirection.Right) {
        z = ((frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.position.z) || 0) - sinkCabinetSize.z / 2 + CORNERDISTANCE + sinkSize.z / 2;
        if (hasHole) {
            x = sinkCabinetBounds.max.x - DISTANCE_FROM_HOLESINK_TO_WALL - sinkSize.x / 2;
        }
        else {
            x = sinkCabinetBounds.min.x + CORNEROUTDISTANCE - TOPPANELCONFIG.DEPTH
                + DISTANCE_FROM_SINK_TO_EDGE + sinkSize.x / 2;
        }
    }
    else {
        z = ((frameMesh === null || frameMesh === void 0 ? void 0 : frameMesh.position.z) || 0) + sinkCabinetSize.z / 2 - CORNERDISTANCE - sinkSize.z / 2;
        if (hasHole) {
            x = sinkCabinetBounds.max.x - DISTANCE_FROM_HOLESINK_TO_WALL - sinkSize.x / 2;
        }
        else {
            x = sinkCabinetBounds.min.x + CORNEROUTDISTANCE - TOPPANELCONFIG.DEPTH
                + DISTANCE_FROM_SINK_TO_EDGE + sinkSize.x / 2;
        }
    }
    return {
        x, y, z,
    };
}
export function getNewSinkHoleInfo(frameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, lengthType) {
    const sinkMeshManage = new MeshManage(sinkMesh);
    const sinkSize = sinkMeshManage.getModelSize();
    const frameMeshManage = new MeshManage(frameMesh);
    let holePosition;
    switch (lengthType) {
        case 'p2x':
            if (cornerCabinetDirection) {
                holePosition = getP2XCornerSinkHolePosition(frameMesh, sinkMesh, topPanelPositionY, sinkInfo.hasHole || false);
            }
            else {
                holePosition = getCommonSinkHolePosition(frameMeshManage, sinkMeshManage, sinkInfo.hasHole || false, topPanelPositionY, 'p2x');
            }
            break;
        case 'x':
            if (cornerCabinetDirection) {
                holePosition = getXCornerSinkHolePosition(frameMesh, sinkMesh, topPanelPositionY, sinkInfo.hasHole || false);
            }
            else {
                holePosition = getCommonSinkHolePosition(frameMeshManage, sinkMeshManage, sinkInfo.hasHole || false, topPanelPositionY, 'x');
            }
            break;
        default:
            if (cornerCabinetDirection) {
                holePosition = getZCornerSinkHolePosition(frameMesh, sinkMesh, topPanelPositionY, sinkInfo.hasHole || false, cornerCabinetDirection);
            }
            else {
                holePosition = getCommonSinkHolePosition(frameMeshManage, sinkMeshManage, sinkInfo.hasHole || false, topPanelPositionY, 'z');
            }
            break;
    }
    const holeSize = {
        width: sinkSize.x,
        height: TOPPANELCONFIG.HEIGHT,
        depth: sinkSize.z,
    };
    return {
        holePosition,
        holeSize,
    };
}
// 老的台面挖洞就是在水槽柜的中心点   转角柜挖洞是在开门的那一边的 距离边缘5cm的地方
/**
 * 获取水槽挖孔的相关定位及尺寸 v2.1（含）及以下水槽挖孔的定位及尺寸
 * @param sinkFrameMesh 水槽柜
 * @param sinkMeshManage 水槽
 * @param topPanelPositionY 台面厚度
 * @param cornerCabinetDirection 台面的高度 需要确定洞在Y轴上面的方向
 * @returns 洞的定位跟尺寸
 */
export function getOldP2XSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection) {
    const sinkCabinetBounds = (sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.getHierarchyBoundingVectors()) || {
        min: new Vector3(0, 0, 0),
        max: new Vector3(0, 0, 0),
    }; // 获取水槽所在柜子的在环境中的最大最小点
    const sinkSize = new MeshManage(sinkMesh).getModelSize();
    const sinkCabinetSize = new MeshManage(sinkFrameMesh).getModelSize();
    const sinkCabinetMeshManage = new MeshManage(sinkFrameMesh);
    let holePosition = null;
    // 在l3上面且是转角柜的一定是左转角
    if (cornerCabinetDirection) {
        holePosition = {
            x: ((sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.position.x) || 0) - sinkCabinetSize.x / 2 + CORNERDISTANCE + sinkSize.x / 2,
            y: topPanelPositionY,
            z: (sinkCabinetBounds.max.z + CORNEROUTDISTANCE + sinkCabinetBounds.min.z) / 2,
        };
    }
    else {
        holePosition = {
            x: sinkCabinetMeshManage.mesh.position.x,
            y: topPanelPositionY,
            z: sinkCabinetMeshManage.mesh.position.z,
        };
    }
    const holeSize = {
        width: sinkSize.x,
        height: TOPPANELCONFIG.HEIGHT,
        depth: sinkSize.z,
    };
    return { holePosition, holeSize };
}
export function getOldXSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection) {
    const sinkCabinetBounds = (sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.getHierarchyBoundingVectors()) || {
        min: new Vector3(0, 0, 0),
        max: new Vector3(0, 0, 0),
    }; // 获取水槽所在柜子的在环境中的最大最小点
    const sinkSize = new MeshManage(sinkMesh).getModelSize();
    const sinkCabinetSize = new MeshManage(sinkFrameMesh).getModelSize();
    const sinkCabinetMeshManage = new MeshManage(sinkFrameMesh);
    let holePosition = null;
    // 如果是l型 转角柜在水槽且水槽在l1上面  那么水槽不可能是左转角  所以只需判断右转角水槽的位置就可以了
    // 位置确定的话用 sinkFrameMesh.position.x+sinkFrameMesh.getModelSize().x +
    if (cornerCabinetDirection) {
        holePosition = {
            x: ((sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.position.x) || 0) - sinkCabinetSize.x / 2 + CORNERDISTANCE + sinkSize.x / 2,
            y: topPanelPositionY,
            z: (sinkCabinetBounds.max.z - CORNEROUTDISTANCE + sinkCabinetBounds.min.z) / 2,
        };
    }
    else {
        holePosition = {
            x: sinkCabinetMeshManage.mesh.position.x,
            // x: sinkCabinetBounds.min.x + (sinkCabinetBounds.max.x - sinkCabinetBounds.min.x) / 2,
            y: topPanelPositionY,
            z: sinkCabinetMeshManage.mesh.position.z,
            // z: (sinkCabinetBounds.max.z - sinkCabinetBounds.min.z) / 2,
        };
    }
    const holeSize = {
        width: sinkSize.x,
        height: TOPPANELCONFIG.HEIGHT,
        depth: sinkSize.z,
    };
    return { holePosition, holeSize };
}
export function getOldZSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection) {
    const sinkSize = new MeshManage(sinkMesh).getModelSize();
    const sinkCabinetSize = new MeshManage(sinkFrameMesh).getModelSize();
    const sinkCabinetMeshManage = new MeshManage(sinkFrameMesh);
    let holePosition = null;
    // 当前拿到的转角柜和水槽的位置信息都是旋转之后的
    // 水槽在转角柜上面 位置应该是距离长边的五公分 短边居中
    if (cornerCabinetDirection) {
        // 如果是L型柜子那么只能是左转角的柜子 才能在转角柜上面放水槽
        if (cornerCabinetDirection === CornerCabinetDirection.Right) {
            holePosition = {
                x: ((sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.position.x) || 0) + HALFCORNEROUTDISTANCE,
                y: topPanelPositionY,
                z: ((sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.position.z) || 0) - sinkCabinetSize.z / 2 + CORNERDISTANCE + sinkSize.z / 2,
            };
        }
        else {
            holePosition = {
                x: ((sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.position.x) || 0) + HALFCORNEROUTDISTANCE,
                y: topPanelPositionY,
                z: ((sinkFrameMesh === null || sinkFrameMesh === void 0 ? void 0 : sinkFrameMesh.position.z) || 0) + sinkCabinetSize.z / 2 - CORNERDISTANCE - sinkSize.z / 2,
            };
        }
    }
    else {
        holePosition = {
            x: sinkCabinetMeshManage.mesh.position.x,
            y: topPanelPositionY,
            z: sinkCabinetMeshManage.mesh.position.z,
        };
    }
    const holeSize = {
        width: sinkSize.x,
        height: TOPPANELCONFIG.HEIGHT,
        depth: sinkSize.z,
    };
    return { holePosition, holeSize };
}
